<template>
  <el-dialog
    title="模型展示"
    :visible.sync="dialogVisible"
    width="70%"
    :before-close="handleClose"
  >
    <div id="showModel" class="model"></div>
    <span slot="footer" class="dialog-footer"> </span>
  </el-dialog>
</template>

<script>
import * as THREE from "three";
import { ColladaLoader } from "three/examples/jsm/loaders/ColladaLoader";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { Group } from "three";

let three_init = {
  scene: null,
  camera: null,
  renderer: null,
  controls: null,
};
export default {
  props: ["model_id", "dialogVisible", "model"],
  // data() {
  //   return {};
  // },
  mounted() {
    let _this = this;
    setTimeout(() => {
      _this.init();
      _this.loadPlant();
      _this.animate();
    }, 200);
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    /**初始化 */
    initScene() {
      three_init.scene = new THREE.Scene();
      three_init.scene.background = new THREE.Color("black");
      const ambientLight = new THREE.AmbientLight(0xcccccc, 0.4);
      three_init.scene.add(ambientLight);
      const helper = new THREE.AxesHelper();
      three_init.scene.add(helper);
    },
    initCamera() {
      const aspect = window.innerWidth / window.innerHeight; //宽高可根据实际项目要求更改 如果是窗口高度改为innerHeight
      three_init.camera = new THREE.PerspectiveCamera(80, aspect, 0.01, 8000);
      three_init.camera.position.set(-20, 10, 20);
      three_init.camera.lookAt(new THREE.Vector3(0, 0, 0)); // 让相机指向原点
      const pointLight = new THREE.PointLight(0xffffff, 0.8);
      three_init.camera.add(pointLight);
      three_init.scene.add(three_init.camera);
    },
    initRenderer() {
      three_init.renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true,
      });
      three_init.renderer.setPixelRatio(window.devicePixelRatio);
      three_init.renderer.setSize(570, 320); //宽高可根据实际项目要求更改 如果是窗口高度改为innerHeight
      // three_init.renderer.domElement.style.position = "absolute";
      // three_init.renderer.domElement.style.top = 0;

      let container = document.getElementById("showModel");
      console.log(document);
      container.appendChild(three_init.renderer.domElement);
    },

    initControl() {
      three_init.controls = new OrbitControls(
        three_init.camera,
        three_init.renderer.domElement
      );
    },
    animate() {
      three_init.renderer.render(three_init.scene, three_init.camera);
      this.requestId = requestAnimationFrame(this.animate);
    },
    init() {
      this.initScene();
      this.initCamera();
      this.initRenderer();
      this.initControl();
    },
    /**加载模型 */
    loadPlant() {
      let that = this;
      let colladaLoader = new ColladaLoader();

      colladaLoader.load(
        this.model.src,
        // "http://wupen-video.oss-cn-shanghai.aliyuncs.com/heritage/model/None04%E5%B1%B1%E8%A5%BF%E4%BA%94%E5%8F%B0%E5%B1%B1%E4%BD%9B%E5%85%89%E5%AF%BA%E5%A2%99%E4%BD%93%E9%97%A8%E7%AA%971652779128000.dae",
        (obj) => {
          let daeModel = obj.scene;
          let my_material = new THREE.MeshPhongMaterial(); //or any other material
          //set map, shininess, etc. if needed
          daeModel.material = my_material;
          console.log(daeModel, obj);
          const boxHelper = new THREE.BoxHelper(daeModel, "white");

          let center = boxHelper.geometry.boundingSphere.center;
          let radius = boxHelper.geometry.boundingSphere.radius;
          console.log(center, radius);
          three_init.scene.add(boxHelper);
          console.log(boxHelper.geometry.attributes);
          // boxHelper.geometry.setAttribute(
          //   "uv2",
          //   new THREE.BufferAttribute(
          //     boxHelper.geometry.attributes.position.array,
          //     2
          //   )
          // );
          // boxHelper.geometry.center();
          daeModel.position.y -= center.y;
          daeModel.position.x -= center.x;
          daeModel.position.z -= center.z;
          three_init.camera.z += radius;
          // (daeModel.name = 1),
          // daeModel.position.set(0, 0, 0);
          // three_init.camera.position.set({
          //   x: daeModel.position.y,
          //   y: daeModel.position.x,
          //   z: daeModel.position.z + 10,
          // });
          console.log(obj);
          three_init.scene.add(daeModel);
        }
      );
    },
  },

  destroyed() {
    cancelAnimationFrame(this.requestId);
    three_init.scene = null;
    three_init.camera = null;
    three_init.renderer = null;
    three_init.controls = null;
    this.CSSRender = null;
    window.removeEventListener("resize", this.onResize, false);
  },
};
</script>

<style scoped lang="scss">
.model {
  position: relative;
  margin: 0 auto;
  height: 320px;
  width: 570px;
  cursor: move;
}
/deep/ .el-dialog {
  width: 31%;
  box-shadow: $boxshadow;
  border-radius: 4px;
  .el-form {
    display: flex;
    justify-content: space-around;
  }
  .el-dialog__body {
    display: flex;
    justify-content: center;
  }
  .el-dialog__footer {
    padding: 10px 25% 20px;
    .dialog-footer {
      height: 28px;
      display: flex;
      justify-content: space-around;
      .el-button--default:hover {
        background: $base-color;
      }
      .el-button--default {
        border-radius: 100px;
        border: 1px solid $schoolTagBorder;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $schoolTagColor;
        }
      }
      .el-button--primary {
        border-radius: 100px;
        background: $pageViewSmall;
        border: 1px solid $pageViewSmall;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $base-color;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/iHeritage/components/ModelShow.vue